/** 
*@author: satyamurthy.a
*@Description : 
**/
import axios from 'axios';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import React, { useEffect, useRef, useState } from 'react';
import Highlighter from 'react-highlight-words';
import localStorage from '../../../utils/localStorage';
import StyledTable from '../../../commons/styles/table';
import { DrawerFooter } from '../../../commons/styles/layout';
import { API_MASTERCONFIGURATION } from '../../../commons/api';
import { Input, Button, Drawer, Select, Space, message, Form } from 'antd';
import { PlusOutlined, MinusCircleOutlined, SearchOutlined } from '@ant-design/icons';

const { Option } = Select;

const MasterConfiguration = ({ translationCache }) => {
  const [visible, setVisible] = useState(false);
  const [editObject, setEditObject] = useState({});
  const [masterList, setMasterList] = useState([]);
  const [masterTableNames, setMasterTableNames] = useState([]);
  const [columnsList, setColumnsList] = useState([]);
  const [unquieColumns, setUnquieColumns] = useState([]);
  const [dynamicEditObject, setDynamicEditObject] = useState({});
  const [searchText, setSearchText] = useState('');
  const searchInput = useRef(null);

  const masterConfig = useRef(null);
  const dynamicConfig = useRef(null);

  useEffect(() => {
    _getMasterList();
    _getTableMasterList();
  }, []);

  const _getTableMasterList = () => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    const Object = {
      method: 'GET',
      url: `${API_MASTERCONFIGURATION.GetTableList}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    axios(Object)
      .then((response) => {
        setMasterTableNames(response.data);
      })
      .catch(() => { });
  };

  const _getMasterList = () => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    const Object = {
      method: 'GET',
      url: `${API_MASTERCONFIGURATION.GET}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    axios(Object)
      .then((response) => {
        setMasterList(response.data);
      })
      .catch(() => { });
  };

  // const updateArray = (array, index, updateFn) => {
  //   return [...array.slice(0, index), updateFn(array[index]), ...array.slice(index + 1)];
  // };

  // const handleFieldChange = (e, parameter, index) => {
  //   let arrayUpdated = updateArray(editObject.columns, index, (item) => ({
  //     ...item,
  //     [parameter]: e
  //   }));
  //   setEditObject({
  //     ...editObject,
  //     columns: arrayUpdated
  //   });
  // };

  const _curdOperation = async (e, operation) => {
    e.preventDefault();
    let columns = [];
    try {
      columns = await dynamicConfig.current.validateFields().then(values => values['columns'] || []);
    } catch (error) {
      console.log(error);
      return;
    }

    const siteId = localStorage.get('currentSite');
    try {
      const values = await masterConfig.current.validateFields();
      let newObj = {
        MasterCode: values.MasterCode,
        MasterName: values.MasterName,
        TableName: values.TableName,
        Type: values.Type,
        JSON: {
          MasterCode: values.MasterCode,
          MasterName: values.MasterName,
          TableName: values.TableName,
          columns: columns,
          uniqueness: values.uniqueness,
          Type: values.Type,
          api: {
            read: {
              url: values.readURL,
              method: values.readMethod
            },
            create: {
              url: values.createURL,
              method: values.createMethod
            },
            update: {
              url: values.updateURL,
              method: values.updateMethod
            },
            delete: {
              url: values.deleteURL,
              method: values.deleteMethod
            }
          }
        },
        SiteId: siteId
      };

      if (operation === 'create') {
        let saveResponse = await _saveMasterData(newObj);
        if (saveResponse && saveResponse.message) {
          setVisible(false);
          _getMasterList();
          message.success(saveResponse.message);
        }
      } else if (operation === 'update') {
        let updateResponse = await _updateMasterData({ ...newObj, Id: editObject.Id });
        if (updateResponse && updateResponse.message) {
          setVisible(false);
          setEditObject({});
          setDynamicEditObject({});
          _getMasterList();
          message.success(updateResponse.message);
        }
      } else if (operation === 'delete') {
        // Handle delete operation inline
        const deleteResponse = await _deleteMasterData(editObject.Id);
        if (deleteResponse && deleteResponse.message) {
          setVisible(false);
          _getMasterList();
          message.success(deleteResponse.message);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };
  const _deleteMasterData = (Id) => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    const config = {
      method: 'DELETE',
      url: `${API_MASTERCONFIGURATION.DELETE}?Id=${Id}&SiteId=${siteId}`,
      headers: { Authorization: `Bearer ${accessToken}` }
    };
    return axios(config).then((response) => { return response.data; }).catch(() => {
      return { message: 'Error' };
    });
  };
  const _saveMasterData = (data) => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    const Object = {
      method: 'POST',
      url: `${API_MASTERCONFIGURATION.CREATE}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      data
    };
    return axios(Object)
      .then((response) => response.data)
      .catch(() => ({ message: 'Error' }));
  };

  const _updateMasterData = (data) => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    const Object = {
      method: 'PATCH',
      url: `${API_MASTERCONFIGURATION.UPDATE}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      data
    };
    return axios(Object)
      .then((response) => response.data)
      .catch(() => ({ message: 'Error' }));
  };

  const translation = (keyword) => {
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };

  const onTableNameChange = (tableName) => {
    let columnsList = masterTableNames && masterTableNames[tableName] ? masterTableNames[tableName] : [];
    setColumnsList(columnsList);
    setUnquieColumns([]);
  };

  const onColumnKeyChange = (value) => {
    setUnquieColumns((prev) => [...prev, value]);
  };

  const onTableClick = (edit) => {
    let editObject = edit.JSON ? edit.JSON : {};
    editObject = {
      ...editObject,
      Id: edit.Id,
      Type: edit.Type,
      createURL: editObject.api?.create?.url || `${API_MASTERCONFIGURATION.Master}`,
      createMethod: editObject.api?.create?.method || 'POST',
      readURL: editObject.api?.read?.url || `${API_MASTERCONFIGURATION.Master}`,
      readMethod: editObject.api?.read?.method || 'POST',
      updateURL: editObject.api?.update?.url || `${API_MASTERCONFIGURATION.Master}`,
      updateMethod: editObject.api?.update?.method || 'POST',
      deleteURL: editObject.api?.delete?.url || `${API_MASTERCONFIGURATION.Master}`,
      deleteMethod: editObject.api?.delete?.method || 'POST'
    };
    onTableNameChange(editObject.TableName);
    let unquieColumns = editObject.columns?.map(columnList => columnList.key).filter(val => !editObject.uniqueness.includes(val)) || [];
    if (masterConfig.current) {
      masterConfig.current.setFieldsValue(editObject);
      dynamicConfig.current.setFieldsValue({ columns: editObject.columns });
    }

    setEditObject(editObject);
    setUnquieColumns(unquieColumns);
    setVisible(true);
    setDynamicEditObject({ columns: editObject.columns });
  };

  const onClose = () => {
    setVisible(false);
    setEditObject({});
    setDynamicEditObject([]);
    if (masterConfig.current || dynamicConfig.current) {
      masterConfig.current.resetFields();
      dynamicConfig.current.resetFields();
    }
  };

  const onFinishFailed = () => {
    message.error(translation('please enter required fields'));
  };

  const addNew = () => {
    if (masterConfig.current || dynamicConfig.current) {
      masterConfig.current.resetFields();
      dynamicConfig.current.resetFields();
    }
    let newEditObject = {
      Type: 'WithSiteId',
      api: {
        read: { url: `${API_MASTERCONFIGURATION.Master}`, method: 'POST' },
        create: { url: `${API_MASTERCONFIGURATION.Master}`, method: 'POST' },
        update: { url: `${API_MASTERCONFIGURATION.Master}`, method: 'POST' },
        delete: { url: `${API_MASTERCONFIGURATION.Master}`, method: 'POST' }
      },
      createURL: `${API_MASTERCONFIGURATION.Master}`,
      createMethod: 'POST',
      readURL: `${API_MASTERCONFIGURATION.Master}`,
      readMethod: 'POST',
      updateURL: `${API_MASTERCONFIGURATION.Master}`,
      updateMethod: 'POST',
      deleteURL: `${API_MASTERCONFIGURATION.Master}`,
      deleteMethod: 'POST'
    };
    setVisible(true);
    setEditObject(newEditObject);
    setDynamicEditObject({});
  };

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setSearchText(selectedKeys[0]);
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    handleSearch([], confirm);
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
                    ref={searchInput}
          placeholder={translation('Search')}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          
          style={{ width: 90, marginRight: 8 }}
        >
          {translation('Search')}
        </Button>
        <Button
          type='primary'
          danger
          onClick={() => handleReset(clearFilters, confirm)}
          
          style={{ width: 90 }}
        >
          {translation('Reset')}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined, }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]?.toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
                setTimeout(() => searchInput.current.select());

      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text?.toString()}
      />
    )
  });

  const columns = [
    {
      title: translation('Master Code'),
      dataIndex: 'MasterCode',
      key: 'MasterCode',
      ...getColumnSearchProps('MasterCode')
    },
    {
      title: translation('Master Name'),
      dataIndex: 'MasterName',
      key: 'MasterName',
      ...getColumnSearchProps('MasterName')
    },
    {
      title: translation('Table Name'),
      dataIndex: 'TableName',
      key: 'TableName',
      ...getColumnSearchProps('TableName')
    },
    {
      title: translation('Action'),
      width: '600',
      render: (text, record) => (
        <>
          <Button
            style={{ marginRight: '5px' }}
            type='primary'
            onClick={() => onTableClick(record)}
            
          >
            {translation('Edit')}
          </Button>
          <Button style={{ marginRight: '5px' }} type='primary' >
            <Link to={{ pathname: `/rubus/settingsPage/master/${record.MasterCode}` }}>
              {translation('View')}
            </Link>
          </Button>
        </>
      )
    }
  ];

  return (
    <>
      <Button
        type="primary"
        style={{ marginBottom: '10px' }}
        onClick={addNew}
      >
        <PlusOutlined /> {translation('Add')}
      </Button>
      <StyledTable size="small" columns={columns} dataSource={masterList} />
      <Drawer
        title={translation('Configuration')}
        placement="right"
        closable
        width={800}
        onClose={onClose}
        open={visible}
      >
        <Form
          layout="vertical"
          ref={masterConfig}
          name="dynamic_form_nest_item1"
          labelCol={{ span: 10 }}
          wrapperCol={{ span: 14 }}
          autoComplete="off"
          initialValues={editObject || {}}
          onFinishFailed={onFinishFailed}
        >
          <Form.Item
            label={translation('Master Code')}
            name="MasterCode"
            rules={[
              { required: true, message: translation('Please input your MasterCode!!') }
            ]}
          >
            <Input
              style={{ width: '300px' }}
              placeholder={translation('Master Code')}
              disabled={!!editObject.MasterCode}
            />
          </Form.Item>
          <Form.Item
            label={translation('Master Name')}
            name="MasterName"
            rules={[
              { required: true, message: translation('Please input your MasterName!!') }
            ]}
          >
            <Input
              style={{ width: '300px' }}
              placeholder={translation('Master Name')}
              disabled={!!editObject.MasterName}
            />
          </Form.Item>
          <Form.Item
            label={translation('Table Name')}
            name="TableName"
            rules={[{ required: true, message: translation('Please select TableName!!') }]}
          >
            <Select
              style={{ width: 300 }}
              placeholder={translation('Table Name')}
              onChange={onTableNameChange}
              disabled={!!editObject.TableName}
            >
              {masterTableNames &&
                Object.keys(masterTableNames)
                  .filter((fil) => !masterList.map((master) => master.TableName).includes(fil))
                  .map((master, index) => (
                    <Option key={index} value={master}>
                      {master}
                    </Option>
                  ))}
            </Select>
          </Form.Item>
          <Form.Item
            label={translation('Type')}
            name="Type"
            rules={[{ required: true, message: translation('Select Type') }]}
          >
            <Select style={{ width: 300 }} placeholder={translation('Type')}>
              <Option key={1} value={'WithSiteId'}>
                {'With SiteId'}
              </Option>
              <Option key={2} value={'WithoutSiteId'}>
                {'WithOut SiteId'}
              </Option>
            </Select>
          </Form.Item>
          <Form.Item
            label={translation('Columns')}
            name="Columns"
            rules={[{ required: false, message: translation('Please select Columns!!') }]}
          >
            <Form
              ref={dynamicConfig}
              name="dynamic_form_nest_item"
              autoComplete="off"
              initialValues={dynamicEditObject || []}
            >
              <Form.List name="columns">
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ key, name, ...restField }, index) => (
                      <Space
                        key={key}
                        style={{ display: 'flex', marginBottom: 8 }}
                        align="baseline"
                      >
                        <Form.Item
                          {...restField}
                          name={[name, 'title']}
                          rules={[
                            {
                              required: true,
                              message: translation('Input Title')
                            }
                          ]}
                        >
                          <Input placeholder={translation('Title')} style={{ width: 150 }} />
                        </Form.Item>
                        <Form.Item
                          {...restField}
                          name={[name, 'key']}
                          rules={[
                            {
                              required: true,
                              message: translation('Select key')
                            }
                          ]}
                        >
                          <Select
                            showArrow
                            showSearch
                            openOnFocus
                            style={{ width: 150 }}
                            onChange={(e) => onColumnKeyChange(e, 'key', index)}
                            placeholder={translation('Key')}
                            filterOption={(input, option) =>
                              option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                          >
                            {columnsList &&
                              Array.isArray(columnsList) &&
                              columnsList
                                .filter((fil) => !editObject && editObject.columns && editObject.columns.map((master) => master.key).includes(fil))
                                .map((keyNames, index) => (
                                  <Option key={index} value={keyNames}>
                                    {keyNames}
                                  </Option>
                                ))}
                          </Select>
                        </Form.Item>
                        <Form.Item
                          {...restField}
                          name={[name, 'widget']}
                          rules={[
                            {
                              required: true,
                              message: translation('Select widget')
                            }
                          ]}
                        >
                          <Select
                            showArrow
                            showSearch
                            openOnFocus
                            style={{ width: 150 }}
                            placeholder={translation('Widget')}
                            filterOption={(input, option) =>
                              option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                          >
                            {['input', 'select'].map((widget, index) => (
                              <Option key={index} value={widget}>
                                {translation(widget)}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                        <Form.Item
                          {...restField}
                          name={[name, 'isMandatory']}
                          rules={[
                            {
                              required: true,
                              message: translation('Select isMandatory')
                            }
                          ]}
                        >
                          <Select
                            openOnFocus
                            style={{ width: 150 }}
                            placeholder={translation('Is Mandatory ?')}
                          >
                            <Option value={true}>{translation('true')}</Option>
                            <Option value={false}>{translation('false')}</Option>
                          </Select>
                        </Form.Item>
                        <Form.Item
                          {...restField}
                          name={[name, 'disableOndelete']}
                          rules={[
                            {
                              required: true,
                              message: translation('Select disableOnUpdate')
                            }
                          ]}
                        >
                          <Select
                            openOnFocus
                            style={{ width: 150 }}
                            placeholder={translation('Is disableOnUpdate ?')}
                          >
                            <Option value={true}>{translation('true')}</Option>
                            <Option value={false}>{translation('false')}</Option>
                          </Select>
                        </Form.Item>
                        <MinusCircleOutlined onClick={() => remove(name)} />
                      </Space>
                    ))}
                    <Form.Item>
                      <Button
                        style={{ width: 150, marginRight: '10px' }}
                        type="dashed"
                        onClick={() => add()}
                        block
                        icon={<PlusOutlined />}
                      >
                        {translation('Add Columns')}
                      </Button>
                      <Button
                        type='primary'
                        onClick={() => {
                          dynamicConfig.current.setFieldsValue({
                            columns: columnsList.map((col) => ({
                              disableOndelete: true,
                              isMandatory: true,
                              key: col,
                              title: col,
                              widget: 'input'
                            }))
                          });
                          setUnquieColumns(columnsList);
                        }}
                      >
                        Generate Columns
                      </Button>
                    </Form.Item>
                  </>
                )}
              </Form.List>
            </Form>
          </Form.Item>

          <Form.Item
            label={translation('Unquie Column Relation')}
            name="uniqueness"
            rules={[{ required: true, message: translation('Please select Uniqueness!!') }]}
          >
            <Select
              style={{ width: 300 }}
              placeholder={translation('Uniqueness')}
              mode="multiple"
            >
              {unquieColumns.map((columns, index) => (
                <Option key={index} value={columns}>
                  {columns}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label={translation('Read URL')}
            name="readURL"
            rules={[{ required: true, message: translation('Please input read URL!!') }]}
          >
            <Input
              style={{ width: 300, marginRight: '5px' }}
              placeholder={translation('Read API URL')}
            />
          </Form.Item>
          <Form.Item
            label={translation('Read Method')}
            name="readMethod"
            rules={[{ required: true, message: translation('Please select Read Method!!') }]}
          >
            <Select style={{ width: 300 }} placeholder={translation('Read API method')}>
              <Option value="POST">POST</Option>
              <Option value="GET">GET</Option>
              <Option value="PATCH">PATCH</Option>
            </Select>
          </Form.Item>

          <Form.Item
            label={translation('Create URL')}
            name="createURL"
            rules={[{ required: true, message: translation('Please input create URL!!') }]}
          >
            <Input
              style={{ width: 300, marginRight: '5px' }}
              placeholder={translation('Create API URL')}
            />
          </Form.Item>
          <Form.Item
            label={translation('Create Method')}
            name="createMethod"
            rules={[{ required: true, message: translation('Please select Create Method!!') }]}
          >
            <Select style={{ width: 300 }} placeholder={translation('Create API method')}>
              <Option value="POST">POST</Option>
              <Option value="GET">GET</Option>
              <Option value="PATCH">PATCH</Option>
            </Select>
          </Form.Item>

          <Form.Item
            label={translation('Update URL')}
            name="updateURL"
            rules={[{ required: true, message: translation('Please input Update URL!!') }]}
          >
            <Input
              style={{ width: 300, marginRight: '5px' }}
              placeholder={translation('Update API URL')}
            />
          </Form.Item>
          <Form.Item
            label={translation('Update Method')}
            name="updateMethod"
            rules={[{ required: true, message: translation('Please select update Method!!') }]}
          >
            <Select style={{ width: 300 }} placeholder={translation('Update API method')}>
              <Option value="POST">POST</Option>
              <Option value="GET">GET</Option>
              <Option value="PATCH">PATCH</Option>
            </Select>
          </Form.Item>

          <Form.Item
            label={translation('Delete URL')}
            name="deleteURL"
            rules={[{ required: true, message: translation('Please input Delete URL!!') }]}
          >
            <Input
              style={{ width: 300, marginRight: '5px' }}
              placeholder={translation('Delete API URL')}
            />
          </Form.Item>
          <Form.Item
            label={translation('Delete Method')}
            name="deleteMethod"
            rules={[{ required: true, message: translation('Please select delete Method!!') }]}
          >
            <Select style={{ width: 300 }} placeholder={translation('Delete API method')}>
              <Option value="POST">POST</Option>
              <Option value="GET">GET</Option>
              <Option value="PATCH">PATCH</Option>
            </Select>
          </Form.Item>
        </Form>
        <DrawerFooter>
          <Button type="primary" onClick={onClose} style={{ marginRight: 8 }}>
            {translation('Cancel')}
          </Button>
          <Button
            onClick={(e) => _curdOperation(e, 'delete')}
            type="primary"
            style={{ marginRight: 8 }}
          >
            {translation('Delete')}
          </Button>
          {editObject.Id === undefined ? (
            <Button onClick={(e) => _curdOperation(e, 'create')} type="primary">
              {translation('Create')}
            </Button>
          ) : (
            <Button onClick={(e) => _curdOperation(e, 'update')} type="primary">
              {translation('Update')}
            </Button>
          )}
        </DrawerFooter>
      </Drawer>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache
  };
};

export default connect(mapStateToProps)(MasterConfiguration);